<template>
  <ShortcutDropdown icon="notif" :count="countUnread">
    <template v-if="notifications.length">
      <NotificationDropdownItem v-for="(notification, index) in notifications" :key="index" :notification="notification"/>
    </template>
    <template v-else>
      <li style="cursor: pointer" class="is--read no-results">
        Vous n'avez pas de notification non-lues. Retrouvez l'historique de vos notifications <u>ici</u>
      </li>
    </template>
    <template v-slot:actions>
      <Link v-if="countUnread" :href="route('notifications.mark-all-as-read')" class="is--min is--light">Tout marquer comme lu</Link>
      <Link :href="route('notifications.center')" class="is--min is--light">Voir tout</Link>
    </template>
  </ShortcutDropdown>
</template>


<script>
import ShortcutDropdown from "@components/ShortcutDropdown";
import NotificationDropdownItem from "@components/notifications/NotificationDropdownItem";
import Link from "@components/navigation/Link";

export default {
  components: {Link, ShortcutDropdown, NotificationDropdownItem },
  computed: {
    countUnread(){
      return this.notifications.length - this.notificationsRead.length
    },
    notifications(){
      return this.$page.props.notifications.filter((notif) => notif.type === 'dropdown')
    },
    notificationsRead() {
      return this.$page.props.notifications.filter((notif) => (notif.type === 'dropdown' && notif.isRead))
    }
  }
}
</script>
